export enum Size {
    SMALL = 'SMALL',
    BIG = 'BIG',
  }
